// Get Unmasking Invitation
export const GET_UNMASKING_INVITATION_REQUEST = 'GET_UNMASKING_INVITATION_REQUEST';
export const GET_UNMASKING_INVITATION_DONE = 'GET_UNMASKING_INVITATION_DONE';
export const GET_UNMASKING_INVITATION_FAILED = 'GET_UNMASKING_INVITATION_FAILED';
